import React from 'react';
import emailjs from 'emailjs-com';

import './css/PasswordRequest.css';

export default function PasswordRequest() {
    function sendEmail(e) {
        e.preventDefault();

        if (!e.target.first_name.value ||
          !e.target.last_name.value ||
          !e.target.from_email.value) {
          alert("Please enter your first and last name, along with a valid email address and the event date with description.");
        } else {
          emailjs.sendForm('gillassocphoto', 'password_reset_template', e.target, 'user_kA97brIZjO1nouWCzOgxd')
              .then((result) => {
                  alert("Thank you for your request. We'll be in contact with you soon.");
                  console.log(result.text);
              }, (error) => {
                  alert("There was a problem submitting your request.");
                  console.log(error.text);
              });
        }
    }

    return (
        <div className="password-request">
          <h2>Password Reset Request</h2>

          <p>Gill Associates Photography will only make portfolios available online for viewing and sale with client permission. If you don't have a confidential Event Name and ID, please submit the form below. You will receive your password information within one business day.</p>
          <br/>

          <form className="password-request-form" onSubmit={sendEmail}>
            <table>
            <tbody>
              <tr>
                <td>First Name: <span className="required">*</span></td>
                <td><input type="text" name="first_name" /></td>
              </tr>
              <tr>
                <td>Last Name: <span className="required">*</span></td>
                <td><input type="text" name="last_name" /></td>
              </tr>
              <tr>
                <td>Email address: <span className="required">*</span></td>
                <td><input type="text" name="from_email" /></td>
              </tr>

              <tr><td colSpan={2}>&nbsp;</td></tr>

              <tr>
                <td colSpan={2}>Event Date and Description:</td>
              </tr>
              <tr>
                <td colSpan={2}><textarea name="event"/></td>
              </tr>

              <tr><td colSpan={2}>&nbsp;</td></tr>

              <tr>
                <td><input type="submit" value="Send" /></td>
              </tr>
            </tbody>
            </table>
          </form>
        </div>
    );
}
